"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EnumBase = /** @class */ (function () {
    function EnumBase(name, id) {
        this.name = name;
        this.id = id;
    }
    return EnumBase;
}());
exports.EnumBase = EnumBase;
var AccountStatus = /** @class */ (function (_super) {
    __extends(AccountStatus, _super);
    function AccountStatus(name, id) {
        return _super.call(this, name, id) || this;
    }
    AccountStatus.GetAll = function () {
        var all = [, AccountStatus.Active, AccountStatus.Inactive];
        return all;
    };
    AccountStatus.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    AccountStatus.Active = new AccountStatus("Active", 1);
    AccountStatus.Inactive = new AccountStatus("InActive", 2);
    return AccountStatus;
}(EnumBase));
exports.AccountStatus = AccountStatus;
var ClientProfileState = /** @class */ (function (_super) {
    __extends(ClientProfileState, _super);
    function ClientProfileState(name, id) {
        return _super.call(this, name, id) || this;
    }
    ClientProfileState.GetAll = function () {
        var all = [, ClientProfileState.Contact, ClientProfileState.Invited, ClientProfileState.Registered, ClientProfileState.Disabled];
        return all;
    };
    ClientProfileState.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ClientProfileState.Contact = new ClientProfileState("Contact", 3);
    ClientProfileState.Invited = new ClientProfileState("Invited", 1);
    ClientProfileState.Registered = new ClientProfileState("Registered", 2);
    ClientProfileState.Disabled = new ClientProfileState("Disabled", 3);
    ClientProfileState.Unknown = new ClientProfileState("Unknown Client Profile State", -1);
    return ClientProfileState;
}(EnumBase));
exports.ClientProfileState = ClientProfileState;
var ProfileType = /** @class */ (function (_super) {
    __extends(ProfileType, _super);
    function ProfileType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ProfileType.GetAll = function () {
        var all = [, ProfileType.Staff, ProfileType.Client, ProfileType.System];
        return all;
    };
    ProfileType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ProfileType.Staff = new ProfileType("Staff", 1);
    ProfileType.Client = new ProfileType("Client", 2);
    ProfileType.System = new ProfileType("System", 3);
    ProfileType.Team = new ProfileType("Team", 4);
    ProfileType.Role = new ProfileType("Role ", 5);
    ProfileType.Unknown = new ProfileType("Unknown Profile Type", -1);
    return ProfileType;
}(EnumBase));
exports.ProfileType = ProfileType;
var AssociationType = /** @class */ (function (_super) {
    __extends(AssociationType, _super);
    function AssociationType(name, id) {
        return _super.call(this, name, id) || this;
    }
    AssociationType.GetAll = function () {
        var all = [, AssociationType.AsWriter, AssociationType.AsEditor, AssociationType.AsAccountOwner, AssociationType.AsEditorialManager, AssociationType.AsPodManager, AssociationType.AsAdmin, AssociationType.AsAccountClient];
        return all;
    };
    AssociationType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    AssociationType.AsWriter = new AssociationType("As Writer", "AsWriter");
    AssociationType.AsEditor = new AssociationType("As Editor", "AsEditor");
    AssociationType.AsAccountOwner = new AssociationType("As AccountOwner", "AsAccountOwner");
    AssociationType.AsEditorialManager = new AssociationType("As Editorial Section Manager", "AsEditorialManager");
    AssociationType.AsPodManager = new AssociationType("As Pod Manager", "AsPodManager");
    AssociationType.AsAdmin = new AssociationType("As Admin", "AsAdmin");
    AssociationType.AsAccountClient = new AssociationType("As Account Client", "AsAccountClient");
    return AssociationType;
}(EnumBase));
exports.AssociationType = AssociationType;
var CdnSslType = /** @class */ (function (_super) {
    __extends(CdnSslType, _super);
    function CdnSslType(name, id) {
        return _super.call(this, name, id) || this;
    }
    CdnSslType.GetAll = function () {
        var all = [, CdnSslType.CloudFront, CdnSslType.Custom, CdnSslType.None];
        return all;
    };
    CdnSslType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    CdnSslType.CloudFront = new CdnSslType("CloudFront SSL", "cloudfront");
    CdnSslType.Custom = new CdnSslType("Custom SSL", "custom");
    CdnSslType.None = new CdnSslType("No SSL", "none");
    return CdnSslType;
}(EnumBase));
exports.CdnSslType = CdnSslType;
var ChannelType = /** @class */ (function (_super) {
    __extends(ChannelType, _super);
    function ChannelType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ChannelType.GetAll = function () {
        var all = [, ChannelType.External, ChannelType.Internal];
        return all;
    };
    ChannelType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ChannelType.External = new ChannelType("External", "external");
    ChannelType.Internal = new ChannelType("Internal", "internal");
    ChannelType.Unknown = new ChannelType("Unknown Channel Type", "unknown");
    return ChannelType;
}(EnumBase));
exports.ChannelType = ChannelType;
var DeliveryStatus = /** @class */ (function (_super) {
    __extends(DeliveryStatus, _super);
    function DeliveryStatus(name, id) {
        return _super.call(this, name, id) || this;
    }
    DeliveryStatus.GetAll = function () {
        var all = [, DeliveryStatus.DelayedTermination, DeliveryStatus.Disabled, DeliveryStatus.Live, DeliveryStatus.Trial];
        return all;
    };
    DeliveryStatus.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    DeliveryStatus.DelayedTermination = new DeliveryStatus("Terminated delay", "terminated delay");
    DeliveryStatus.Disabled = new DeliveryStatus("Disabled", "disabled");
    DeliveryStatus.Live = new DeliveryStatus("Live", "live");
    DeliveryStatus.Trial = new DeliveryStatus("Trial", "trial");
    return DeliveryStatus;
}(EnumBase));
exports.DeliveryStatus = DeliveryStatus;
var DeliveryType = /** @class */ (function (_super) {
    __extends(DeliveryType, _super);
    function DeliveryType(name, id) {
        return _super.call(this, name, id) || this;
    }
    DeliveryType.GetAll = function () {
        var all = [, DeliveryType.Api, DeliveryType.Dnxml, DeliveryType.Video];
        return all;
    };
    DeliveryType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    DeliveryType.Api = new DeliveryType("API", "api");
    DeliveryType.Dnxml = new DeliveryType("DNXML", "feeds");
    DeliveryType.Video = new DeliveryType("Video", "video");
    DeliveryType.Unknown = new DeliveryType("Unknown Delivery Type", "unknown");
    return DeliveryType;
}(EnumBase));
exports.DeliveryType = DeliveryType;
var ArticleState = /** @class */ (function (_super) {
    __extends(ArticleState, _super);
    function ArticleState(name, id) {
        return _super.call(this, name, id) || this;
    }
    ArticleState.GetAll = function () {
        var all = [, ArticleState.Approval, ArticleState.Deleted, ArticleState.Draft, ArticleState.Editing, ArticleState.FinalDraft, ArticleState.Live, ArticleState.Revision];
        return all;
    };
    ArticleState.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ArticleState.Approval = new ArticleState("Approval", 6);
    ArticleState.Deleted = new ArticleState("Deleted", 8);
    ArticleState.Draft = new ArticleState("Initial Draft", 1);
    ArticleState.Editing = new ArticleState("Editing", 2);
    ArticleState.FinalDraft = new ArticleState("Final Draft", 5);
    ArticleState.Live = new ArticleState("Live", 7);
    ArticleState.Revision = new ArticleState("Revision", 3);
    ArticleState.Unknown = new ArticleState("Unknown Article State", -1);
    return ArticleState;
}(EnumBase));
exports.ArticleState = ArticleState;
var ArticleType = /** @class */ (function (_super) {
    __extends(ArticleType, _super);
    function ArticleType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ArticleType.GetAll = function () {
        var all = [, ArticleType.Article, ArticleType.Script];
        return all;
    };
    ArticleType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ArticleType.Article = new ArticleType("Article", "Article");
    ArticleType.Script = new ArticleType("Script", "Script");
    ArticleType.Unknown = new ArticleType("Unknown Article Type", "unknown");
    return ArticleType;
}(EnumBase));
exports.ArticleType = ArticleType;
var ArticleAlertType = /** @class */ (function (_super) {
    __extends(ArticleAlertType, _super);
    function ArticleAlertType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ArticleAlertType.GetAll = function () {
        var all = [, ArticleAlertType.ApprovalAlert, ArticleAlertType.ArticleAlert];
        return all;
    };
    ArticleAlertType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ArticleAlertType.ApprovalAlert = new ArticleAlertType("ApprovalAlert", 1);
    ArticleAlertType.ArticleAlert = new ArticleAlertType("ArticleAlert", 2);
    ArticleAlertType.Unknown = new ArticleAlertType("Unknown Article Alert Type", -1);
    return ArticleAlertType;
}(EnumBase));
exports.ArticleAlertType = ArticleAlertType;
var SubscriptionType = /** @class */ (function (_super) {
    __extends(SubscriptionType, _super);
    function SubscriptionType(name, id) {
        return _super.call(this, name, id) || this;
    }
    SubscriptionType.GetAll = function () {
        var all = [, SubscriptionType.ArticleApprovals, SubscriptionType.ArticlePublished, SubscriptionType.MarProLeadEvents];
        return all;
    };
    SubscriptionType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    SubscriptionType.ArticleApprovals = new SubscriptionType("Article Approvals", 1);
    SubscriptionType.ArticlePublished = new SubscriptionType("Article Published", 2);
    SubscriptionType.MarProLeadEvents = new SubscriptionType("MarPro Lead Events", 3);
    SubscriptionType.Unknown = new SubscriptionType("Unknown Subscription", -1);
    return SubscriptionType;
}(EnumBase));
exports.SubscriptionType = SubscriptionType;
var AwsAccountType = /** @class */ (function (_super) {
    __extends(AwsAccountType, _super);
    function AwsAccountType(name, id) {
        return _super.call(this, name, id) || this;
    }
    AwsAccountType.GetAll = function () {
        var all = [, AwsAccountType.OriginalAccount, AwsAccountType.CdnAccount, AwsAccountType.AdferoAccount];
        return all;
    };
    AwsAccountType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    AwsAccountType.OriginalAccount = new AwsAccountType("Original Account", 1);
    AwsAccountType.CdnAccount = new AwsAccountType("Cdn Account", 2);
    AwsAccountType.AdferoAccount = new AwsAccountType("Adfero Account", 3);
    return AwsAccountType;
}(EnumBase));
exports.AwsAccountType = AwsAccountType;
var AllocationType = /** @class */ (function (_super) {
    __extends(AllocationType, _super);
    function AllocationType(name, id) {
        return _super.call(this, name, id) || this;
    }
    AllocationType.GetAll = function () {
        var all = [, AllocationType.Rolling, AllocationType.Fixed];
        return all;
    };
    AllocationType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    AllocationType.Rolling = new AllocationType("Rolling", "Rolling");
    AllocationType.Fixed = new AllocationType("Fixed", "Fixed");
    return AllocationType;
}(EnumBase));
exports.AllocationType = AllocationType;
var AllocationWorkType = /** @class */ (function (_super) {
    __extends(AllocationWorkType, _super);
    function AllocationWorkType(name, id) {
        return _super.call(this, name, id) || this;
    }
    AllocationWorkType.GetAll = function () {
        var all = [, AllocationWorkType.Writing, AllocationWorkType.Editing];
        return all;
    };
    AllocationWorkType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    AllocationWorkType.Writing = new AllocationWorkType("Writing Work", 0);
    AllocationWorkType.Editing = new AllocationWorkType("Editing Work", 1);
    return AllocationWorkType;
}(EnumBase));
exports.AllocationWorkType = AllocationWorkType;
var FieldPopulateType = /** @class */ (function (_super) {
    __extends(FieldPopulateType, _super);
    function FieldPopulateType(name, id) {
        return _super.call(this, name, id) || this;
    }
    FieldPopulateType.GetAll = function () {
        var all = [, FieldPopulateType.Manual, FieldPopulateType.Auto, FieldPopulateType.Off];
        return all;
    };
    FieldPopulateType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    FieldPopulateType.Manual = new FieldPopulateType("Manual", "Manual");
    FieldPopulateType.Auto = new FieldPopulateType("Auto", "Auto");
    FieldPopulateType.Off = new FieldPopulateType("Off", "Off");
    return FieldPopulateType;
}(EnumBase));
exports.FieldPopulateType = FieldPopulateType;
var ProductStatus = /** @class */ (function (_super) {
    __extends(ProductStatus, _super);
    function ProductStatus(name, id) {
        return _super.call(this, name, id) || this;
    }
    ProductStatus.GetAll = function () {
        var all = [, ProductStatus.Live, ProductStatus.Suspended, ProductStatus.Terminated, ProductStatus.NotYetLive, ProductStatus.Paused, ProductStatus.NotAllocated, ProductStatus.EndingSoon];
        return all;
    };
    ProductStatus.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ProductStatus.Live = new ProductStatus("Live", "Live");
    ProductStatus.Suspended = new ProductStatus("Suspended", "Suspended");
    ProductStatus.Terminated = new ProductStatus("Terminated", "Terminated");
    ProductStatus.NotYetLive = new ProductStatus("Not Yet Live", "Not Yet Live");
    ProductStatus.Paused = new ProductStatus("Paused", "Paused");
    ProductStatus.NotAllocated = new ProductStatus("Not Allocated", "NotAllocated");
    ProductStatus.EndingSoon = new ProductStatus("Ending Soon", "EndingSoon");
    return ProductStatus;
}(EnumBase));
exports.ProductStatus = ProductStatus;
var ProductTermType = /** @class */ (function (_super) {
    __extends(ProductTermType, _super);
    function ProductTermType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ProductTermType.GetAll = function () {
        var all = [, ProductTermType.Rolling, ProductTermType.Fixed, ProductTermType.Suspension, ProductTermType.StartingBalance, ProductTermType.ManualAdjustment, ProductTermType.Pause, ProductTermType.ResumedPause];
        return all;
    };
    ProductTermType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ProductTermType.Rolling = new ProductTermType("Rolling", "Rolling");
    ProductTermType.Fixed = new ProductTermType("Fixed", "Fixed");
    ProductTermType.Suspension = new ProductTermType("Suspension", "Suspension");
    ProductTermType.StartingBalance = new ProductTermType("Starting Balance", "Balance");
    ProductTermType.ManualAdjustment = new ProductTermType("Manual Adjustment", "Adjustment");
    ProductTermType.Pause = new ProductTermType("Pause", "Pause");
    ProductTermType.ResumedPause = new ProductTermType("Resumed Pause", "Resumed");
    return ProductTermType;
}(EnumBase));
exports.ProductTermType = ProductTermType;
var InlineImageBorderType = /** @class */ (function (_super) {
    __extends(InlineImageBorderType, _super);
    function InlineImageBorderType(name, id) {
        return _super.call(this, name, id) || this;
    }
    InlineImageBorderType.GetAll = function () {
        var all = [, InlineImageBorderType.BorderTop, InlineImageBorderType.BorderBottom, InlineImageBorderType.BorderBottomLeft, InlineImageBorderType.None];
        return all;
    };
    InlineImageBorderType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    InlineImageBorderType.BorderTop = new InlineImageBorderType("Top", "Border Top");
    InlineImageBorderType.BorderBottom = new InlineImageBorderType("Bottom", "Border Bottom");
    InlineImageBorderType.BorderBottomLeft = new InlineImageBorderType("Bottom Left", "Border Bottom Left");
    InlineImageBorderType.None = new InlineImageBorderType("None", "None");
    return InlineImageBorderType;
}(EnumBase));
exports.InlineImageBorderType = InlineImageBorderType;
var EncodingStatus = /** @class */ (function (_super) {
    __extends(EncodingStatus, _super);
    function EncodingStatus(name, id) {
        return _super.call(this, name, id) || this;
    }
    EncodingStatus.GetAll = function () {
        var all = [];
        return all;
    };
    EncodingStatus.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    return EncodingStatus;
}(EnumBase));
exports.EncodingStatus = EncodingStatus;
var EncodingStatusType = /** @class */ (function (_super) {
    __extends(EncodingStatusType, _super);
    function EncodingStatusType(name, id) {
        return _super.call(this, name, id) || this;
    }
    EncodingStatusType.GetAll = function () {
        var all = [, EncodingStatusType.Submitted, EncodingStatusType.Progressing, EncodingStatusType.Complete, EncodingStatusType.Error];
        return all;
    };
    EncodingStatusType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    EncodingStatusType.Submitted = new EncodingStatusType("Submitted", "Submitted");
    EncodingStatusType.Progressing = new EncodingStatusType("Progressing", "Progressing");
    EncodingStatusType.Complete = new EncodingStatusType("Complete", "Complete");
    EncodingStatusType.Error = new EncodingStatusType("Error", "Error");
    return EncodingStatusType;
}(EnumBase));
exports.EncodingStatusType = EncodingStatusType;
var SplashType = /** @class */ (function (_super) {
    __extends(SplashType, _super);
    function SplashType(name, id) {
        return _super.call(this, name, id) || this;
    }
    SplashType.GetAll = function () {
        var all = [, SplashType.PostSplash, SplashType.PreSplash, SplashType.None];
        return all;
    };
    SplashType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    SplashType.PostSplash = new SplashType("PostSplash", "PostSplash");
    SplashType.PreSplash = new SplashType("PreSplash", "PreSplash");
    SplashType.None = new SplashType("None", "None");
    return SplashType;
}(EnumBase));
exports.SplashType = SplashType;
var VideoType = /** @class */ (function (_super) {
    __extends(VideoType, _super);
    function VideoType(name, id) {
        return _super.call(this, name, id) || this;
    }
    VideoType.GetAll = function () {
        var all = [, VideoType.ManualVideo, VideoType.StandardVideo];
        return all;
    };
    VideoType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    VideoType.ManualVideo = new VideoType("Manual Video", "Manual Video");
    VideoType.StandardVideo = new VideoType("Standard Video", "Standard Video");
    return VideoType;
}(EnumBase));
exports.VideoType = VideoType;
var BusinessUnit = /** @class */ (function (_super) {
    __extends(BusinessUnit, _super);
    function BusinessUnit(name, id) {
        return _super.call(this, name, id) || this;
    }
    BusinessUnit.GetAll = function () {
        var all = [, BusinessUnit.Brafton, BusinessUnit.ContentLead, BusinessUnit.Castleford, BusinessUnit.UK, BusinessUnit.Unknown];
        return all;
    };
    BusinessUnit.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    BusinessUnit.Brafton = new BusinessUnit("Brafton", 2);
    BusinessUnit.ContentLead = new BusinessUnit("ContentLead", 1);
    BusinessUnit.Castleford = new BusinessUnit("Castleford", 7);
    BusinessUnit.UK = new BusinessUnit("UK", 8);
    BusinessUnit.Unknown = new BusinessUnit("Unknown Business Unit", -1);
    return BusinessUnit;
}(EnumBase));
exports.BusinessUnit = BusinessUnit;
var ImageAccessLevel = /** @class */ (function (_super) {
    __extends(ImageAccessLevel, _super);
    function ImageAccessLevel(name, id) {
        return _super.call(this, name, id) || this;
    }
    ImageAccessLevel.GetAll = function () {
        var all = [, ImageAccessLevel.Private, ImageAccessLevel.Public];
        return all;
    };
    ImageAccessLevel.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ImageAccessLevel.Private = new ImageAccessLevel("Private", "Private");
    ImageAccessLevel.Public = new ImageAccessLevel("Public", "Public");
    return ImageAccessLevel;
}(EnumBase));
exports.ImageAccessLevel = ImageAccessLevel;
var WorkflowMode = /** @class */ (function (_super) {
    __extends(WorkflowMode, _super);
    function WorkflowMode(name, id) {
        return _super.call(this, name, id) || this;
    }
    WorkflowMode.GetAll = function () {
        var all = [, WorkflowMode.AutoArticle, WorkflowMode.UniqueArticle];
        return all;
    };
    WorkflowMode.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    WorkflowMode.AutoArticle = new WorkflowMode("Auto Article", 1);
    WorkflowMode.UniqueArticle = new WorkflowMode("Unique Article", 2);
    WorkflowMode.Unknown = new WorkflowMode("Unknown Workflow Mode", -1);
    return WorkflowMode;
}(EnumBase));
exports.WorkflowMode = WorkflowMode;
var AllocationMultiplier = /** @class */ (function (_super) {
    __extends(AllocationMultiplier, _super);
    function AllocationMultiplier(name, id) {
        return _super.call(this, name, id) || this;
    }
    AllocationMultiplier.GetAll = function () {
        var all = [, AllocationMultiplier.SMEEditing, AllocationMultiplier.SMEWriting, AllocationMultiplier.Proofing, AllocationMultiplier.Quality, AllocationMultiplier.Sourcing, AllocationMultiplier.Handling];
        return all;
    };
    AllocationMultiplier.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    AllocationMultiplier.SMEEditing = new AllocationMultiplier("SME - Editing", 1);
    AllocationMultiplier.SMEWriting = new AllocationMultiplier("SME - Writing", 2);
    AllocationMultiplier.Proofing = new AllocationMultiplier("Proofing", 3);
    AllocationMultiplier.Quality = new AllocationMultiplier("Quality", 4);
    AllocationMultiplier.Sourcing = new AllocationMultiplier("Sourcing", 5);
    AllocationMultiplier.Handling = new AllocationMultiplier("Handling", 6);
    return AllocationMultiplier;
}(EnumBase));
exports.AllocationMultiplier = AllocationMultiplier;
var ContractFrequency = /** @class */ (function (_super) {
    __extends(ContractFrequency, _super);
    function ContractFrequency(name, id) {
        return _super.call(this, name, id) || this;
    }
    ContractFrequency.GetAll = function () {
        var all = [, ContractFrequency.Monthly, ContractFrequency.Quarterly, ContractFrequency.Yearly, ContractFrequency.SemiAnnual];
        return all;
    };
    ContractFrequency.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ContractFrequency.Monthly = new ContractFrequency("Monthly", 1);
    ContractFrequency.Quarterly = new ContractFrequency("Quarterly", 2);
    ContractFrequency.Yearly = new ContractFrequency("Yearly", 3);
    ContractFrequency.SemiAnnual = new ContractFrequency("Semi-Annyal", 4);
    return ContractFrequency;
}(EnumBase));
exports.ContractFrequency = ContractFrequency;
var ApiField = /** @class */ (function (_super) {
    __extends(ApiField, _super);
    function ApiField(name, id) {
        return _super.call(this, name, id) || this;
    }
    ApiField.GetAll = function () {
        var all = [, ApiField.Extract, ApiField.Source, ApiField.Keywords, ApiField.Tags, ApiField.Byline, ApiField.TweetText, ApiField.TitleTag, ApiField.DescriptionTag, ApiField.KeywordsTag, ApiField.Summary, ApiField.LongHeading];
        return all;
    };
    ApiField.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ApiField.Extract = new ApiField("Extract", 1);
    ApiField.Source = new ApiField("Source", 2);
    ApiField.Keywords = new ApiField("Keywords", 3);
    ApiField.Tags = new ApiField("Tags", 4);
    ApiField.Byline = new ApiField("Byline", 5);
    ApiField.TweetText = new ApiField("Tweet Text", 6);
    ApiField.TitleTag = new ApiField("TitleTag", 7);
    ApiField.DescriptionTag = new ApiField("Description Tag", 8);
    ApiField.KeywordsTag = new ApiField("Keywords Tag", 9);
    ApiField.Summary = new ApiField("Summary", 10);
    ApiField.LongHeading = new ApiField("LongHeading", 11);
    ApiField.Unknown = new ApiField("Unknown API field", -1);
    return ApiField;
}(EnumBase));
exports.ApiField = ApiField;
var ImageSizePreset = /** @class */ (function (_super) {
    __extends(ImageSizePreset, _super);
    function ImageSizePreset(name, id) {
        return _super.call(this, name, id) || this;
    }
    ImageSizePreset.GetAll = function () {
        var all = [, ImageSizePreset.Small, ImageSizePreset.Medium, ImageSizePreset.Large, ImageSizePreset.Custom, ImageSizePreset.HighResolution];
        return all;
    };
    ImageSizePreset.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ImageSizePreset.Small = new ImageSizePreset("Small", "Small");
    ImageSizePreset.Medium = new ImageSizePreset("Medium", "Medium");
    ImageSizePreset.Large = new ImageSizePreset("Large", "Large");
    ImageSizePreset.Custom = new ImageSizePreset("Custom", "Custom");
    ImageSizePreset.HighResolution = new ImageSizePreset("High Resolution", "HighRes");
    return ImageSizePreset;
}(EnumBase));
exports.ImageSizePreset = ImageSizePreset;
var ArticleAlertResult = /** @class */ (function (_super) {
    __extends(ArticleAlertResult, _super);
    function ArticleAlertResult(name, id) {
        return _super.call(this, name, id) || this;
    }
    ArticleAlertResult.GetAll = function () {
        var all = [, ArticleAlertResult.Success, ArticleAlertResult.Fail, ArticleAlertResult.Pending];
        return all;
    };
    ArticleAlertResult.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ArticleAlertResult.Success = new ArticleAlertResult("Success", "Success");
    ArticleAlertResult.Fail = new ArticleAlertResult("Fail", "Fail");
    ArticleAlertResult.Pending = new ArticleAlertResult("Pending", "Pending");
    return ArticleAlertResult;
}(EnumBase));
exports.ArticleAlertResult = ArticleAlertResult;
var ProfileAvailabilityTermType = /** @class */ (function (_super) {
    __extends(ProfileAvailabilityTermType, _super);
    function ProfileAvailabilityTermType(name, id) {
        return _super.call(this, name, id) || this;
    }
    ProfileAvailabilityTermType.GetAll = function () {
        var all = [ProfileAvailabilityTermType.PTO, ProfileAvailabilityTermType.Sick, ProfileAvailabilityTermType.NationalHoliday, ProfileAvailabilityTermType.Leave,
            ProfileAvailabilityTermType.Travel, ProfileAvailabilityTermType.Work, ProfileAvailabilityTermType.Weekend, ProfileAvailabilityTermType.Overtime];
        return all;
    };
    ProfileAvailabilityTermType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ProfileAvailabilityTermType.Sick = new ProfileAvailabilityTermType("Sick", "Sick");
    ProfileAvailabilityTermType.PTO = new ProfileAvailabilityTermType("PTO", "PTO");
    ProfileAvailabilityTermType.NationalHoliday = new ProfileAvailabilityTermType("National Holiday", "NationalHoliday");
    ProfileAvailabilityTermType.Leave = new ProfileAvailabilityTermType("Leave", "Leave");
    ProfileAvailabilityTermType.Travel = new ProfileAvailabilityTermType("Travel", "Travel");
    ProfileAvailabilityTermType.Work = new ProfileAvailabilityTermType("Work", "Work");
    ProfileAvailabilityTermType.Weekend = new ProfileAvailabilityTermType("Weekend", "Weekend");
    ProfileAvailabilityTermType.Overtime = new ProfileAvailabilityTermType("Overtime", "Overtime");
    ProfileAvailabilityTermType.Unknown = new ProfileAvailabilityTermType("Unknown Profile Availability Term Type", "UnknownProfileAvailabilityTermType");
    return ProfileAvailabilityTermType;
}(EnumBase));
exports.ProfileAvailabilityTermType = ProfileAvailabilityTermType;
